import { BrowserCacheLocation, PublicClientApplication } from "@azure/msal-browser";
import axios from "axios";
import settings from "client.settings.json";
import { PageComponent } from "components/page";
import { useState } from "react";

const { api } = settings;

const MsOpenIdConnect = ({ setError, tenantId, messageId, authenticators, mappings }) => {
  const [isLoggingIn, setIsLoggingIn] = useState(false);
  const [{ _id: authId }] = authenticators;

  const handleClick = async () => {
    try {
      setIsLoggingIn(true);
      const res = await axios.post(`${api}/api/login/oidc/microsoft/config`, { messageId });
      const { clientId, redirectUri, scopes } = res.data;
      const cache = { cacheLocation: BrowserCacheLocation.MemoryStorage };
      const msalConfig = { auth: { clientId }, cache };
      const msalInstance = new PublicClientApplication(msalConfig);
      const config = { redirectUri, scopes };
      const { idToken } = await msalInstance.loginPopup(config);
      await axios.post(`${api}/api/login/oidc/microsoft`, { authId, idToken, messageId, tenantId });
    } catch (error) {
      setError(error);
    } finally {
      setIsLoggingIn(false);
    }
  };

  return (
    <>
      <PageComponent
        noHeader={true}
        content={mappings["E_DELIVERY_LOGIN_PAGE_OIDC_MS"]}
        btnFunctions={[() => handleClick()]}
        disabled={isLoggingIn}
      />
    </>
  );
};

export default MsOpenIdConnect;
